"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLHyperlinkElementUtilsImpl = require("./HTMLHyperlinkElementUtils-impl").implementation;

var HTMLAnchorElementImpl =
/*#__PURE__*/
function (_HTMLElementImpl) {
  _inherits(HTMLAnchorElementImpl, _HTMLElementImpl);

  function HTMLAnchorElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLAnchorElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLAnchorElementImpl).call(this, args, privateData));

    _this._htmlHyperlinkElementUtilsSetup();

    return _this;
  }

  _createClass(HTMLAnchorElementImpl, [{
    key: "text",
    get: function get() {
      return this.textContent;
    },
    set: function set(v) {
      this.textContent = v;
    }
  }]);

  return HTMLAnchorElementImpl;
}(HTMLElementImpl);

mixin(HTMLAnchorElementImpl.prototype, HTMLHyperlinkElementUtilsImpl.prototype);
module.exports = {
  implementation: HTMLAnchorElementImpl
};